import React, { useState, useEffect } from "react";
import { Grid, InputLabel, MenuItem } from "@mui/material";
import {
  PrimaryOutlinedButton,
  PrimaryLightInput,
  PrimaryLightSelect,
} from "../../theme/index";
import "../../sass/styles.scss";
import FormControl from "@mui/material/FormControl";
import { useDispatch } from "react-redux";
import { modalAction } from "../../redux/reducers/Modal";
import axios from "axios";
import { editRoomAction, editLevelAction } from "../../redux/reducers/Edit";
import {collection, getDocs, addDoc, query, doc} from 'firebase/firestore';
import db from "../../config/firebase";

const EditLevel = (props) => {
  const dispatch = useDispatch();
  const [id, setId] = useState(props.level.id);
  const [name, setName] = useState(props.level.name);
  const [status, setStatus] = useState(props.level.status);

  const editRoom = (response, roomStatus) => {
    const roomEdited = new FormData();
    const dataNames = [
      "id",
      "roomNumber",
      "category",
      "price",
      "level",
      "status",
      "details",
    ];

    roomEdited.append(dataNames[0], response.id);
    roomEdited.append(dataNames[1], response.roomNumber);
    roomEdited.append(dataNames[2], response.category);
    roomEdited.append(dataNames[3], response.price);
    roomEdited.append(dataNames[4], response.level);
    roomEdited.append(dataNames[5], roomStatus);
    roomEdited.append(dataNames[6], response.details);
    roomEdited.append("METHOD", "PUT");

    dispatch(editRoomAction(roomEdited, dataNames, response.id));
    console.log(response);
    console.log(roomStatus);
    //dispatch(modalAction());
  };

  const editLevel = () => {
    const levelEdited = new FormData();
    const dataNames = ["id", "name", "status"];

    levelEdited.append(dataNames[0], id);
    levelEdited.append(dataNames[1], name);
    levelEdited.append(dataNames[2], status);
    levelEdited.append("METHOD", "PUT");

    // change status for all rooms when the level has been disabled
    // petition for all rooms
    const getAllRooms = async () => {
      const q = query(collection(db, "room"));
      const querySnapshot = await getDocs(q);
      let roomArray = [];
      querySnapshot.forEach((doc) => {
        roomArray.push(doc.data());
      });
      // check level of the room with this (status)
      roomArray.map( (item) => {
          if( item.level == id ){
              ( status == false ) ? editRoom(item, 'disabled') : editRoom(item, 'open')
          }
      } )
    };

    getAllRooms();

    dispatch(editLevelAction(levelEdited, dataNames, id));
    dispatch(modalAction());
  };

  return (
    <>
      <Grid item xs={10}>
        <h5 style={{ margin: "0" }}>Nivel / editar</h5>
      </Grid>
      <Grid item xs={12}>
        <Grid container sx={{ py: 3 }}>
          <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Nombre"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value={true}>Activo</MenuItem>
                <MenuItem value={false}>Inactivo</MenuItem>
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }} textAlign="end" className="pr-2">
        <PrimaryOutlinedButton onClick={() => editLevel()}>
          Guardar
        </PrimaryOutlinedButton>
      </Grid>
    </>
  );
};

export default EditLevel;
